// extracted by mini-css-extract-plugin
module.exports = {"redirect":"RedirectBtn_redirect__3EEd8","default":"RedirectBtn_default__2mjZO","sideMenu":"RedirectBtn_sideMenu__1Eym6","header":"RedirectBtn_header__3HE_d"};